export const theme = {
    primary: '#3b82f6',
    warning: '#eab308',
    glow: '#3b82f6',
    bg: '#f8fafc',
    textMain: '#1e293b',
    textMuted: '#64748b',
    border: '#e2e8f0',
    danger: '#ef4444'
};

export const ALL_MODELS = [
    'yellow_plug', 'grey_plug', 'm12_12_male', 'm12_12_female', 'm12_8_male',
    'm12_8_female', 'm12_5_male', 'm12_5_female', 'cable_gland', 'e_stop_led',
    'e_stop_no_led', 'switch', 'key_switch', 'push_button', 'plug_button', 'm12_12_female_field',
    'm12_8_female_field', 'm12_5_female_field', 'sd_card', 'relay', 'can_single',
    'can_double', 'antenna'
];

export const slotPositions = {
    Q1: { x: -0.18, y: -2.0, z: 0.15 }, Q2: { x: -0.18, y: 2.0, z: 0.15 },
    Q3: { x: 0.18, y: -2.0, z: -0.2 }, Q4: { x: 0.18, y: 2.0, z: -0.2 },
    Q5: { x: 0.5, y: 1.15, z: 0.0 }, Q6: { x: 0.5, y: 0.6, z: 0.0 },
    Q7: { x: 0.5, y: 0.05, z: 0.0 }, Q8: { x: 0.5, y: -0.5, z: 0.0 },
    Q9: { x: 0.5, y: -1.3, z: -0.1 },
    sd_card: { x: 0, y: -0.7, z: -0.3 },
    relay: { x: 0, y: 0.5, z: -0.2 },
    can_single: { x: 0, y: -1.5, z: -0.1 },
    can_double: { x: 0, y: -1.5, z: -0.1 },
    antenna: { x: -0.3, y: -2.1, z: -0.2 }
};

export const connectorOptions = [
    { variant: 'yellow_plug', name: 'Yellow Plug', code: 'A0' },
    { variant: 'grey_plug', name: 'Grey Plug', code: 'A0' },
    { variant: 'm12_5_male', name: 'M12-5M', code: 'M5' },
    { variant: 'm12_5_female', name: 'M12-5F', code: 'F5' },
    { variant: 'm12_5_female', name: 'M12-5F for safety devices', code: 'H0' },
    { variant: 'm12_5_male', name: 'M12-5M 24VDC', code: 'CD' },
    { variant: 'm12_5_male', name: 'M12-5M CAN & 24VDC In', code: 'CC' },
    { variant: 'm12_5_female', name: 'M12-5F CAN & 24VDC Out', code: 'HC' },
    { variant: 'm12_8_male', name: 'M12-8M', code: 'M8' },
    { variant: 'm12_8_female', name: 'M12-8F', code: 'F8' },
    { variant: 'm12_8_female', name: 'M12-8F SAFIX', code: 'IA' },
    { variant: 'm12_8_female', name: 'M12-8F (2 x SAFIX)', code: 'IM' },
    { variant: 'm12_8_female', name: 'M12-8F HoldX', code: 'IE' },
    { variant: 'm12_8_female', name: 'M12-8F (2 x HoldX)', code: 'IH' },
    { variant: 'm12_8_female', name: 'M12-8F IDEM', code: 'IF' },
    { variant: 'm12_8_female', name: 'M12-8F Eden', code: 'IP' },
    { variant: 'm12_8_male', name: 'M12-8M (2 x double NO)', code: 'DB' },
    { variant: 'm12_8_male', name: 'M12-8M (4 x single NO)', code: 'DC' },
    { variant: 'm12_12_male', name: 'M12-12M', code: 'M2' },
    { variant: 'm12_12_female', name: 'M12-12F', code: 'F2' },
    { variant: 'cable_gland', name: 'Cable Gland', code: '01' },
    { variant: 'none', name: 'None', code: '00' }
];

export const housingOptionsFull = [
    { variant: 'e_stop_led', name: 'E-Stop (LED)', code: 'E2' },
    { variant: 'e_stop_no_led', name: 'E-Stop (No LED)', code: 'E2' },
    { variant: 'push_button', name: 'Push Button', code: 'I1' },
    { variant: 'plug_button', name: 'Plug', code: 'A0' },
    { variant: 'switch', name: 'Selector', code: 'G2' },
    { variant: 'switch', name: 'Spring Selector', code: 'G1' },
    { variant: 'key_switch', name: 'Key Selector', code: 'K4' },
    { variant: 'key_switch', name: 'Spring Key Selector', code: 'K3' },
    { variant: 'm12_5_female_field', name: 'M12-5F Field', code: 'F5' },
    { variant: 'm12_8_female_field', name: 'M12-8F Field', code: 'F8' },
    { variant: 'm12_12_female_field', name: 'M12-12F Field', code: 'F2' },
    { variant: 'none', name: 'Empty', code: '00' }
];

export const housingOptionsRestricted = housingOptionsFull.filter(opt =>
    opt.variant !== 'e_stop_led' && opt.variant !== 'e_stop_no_led'
);

export const LAMBDA_URL = "https://mvgcdukyvdsfqxc4vmoemadm540yzkhs.lambda-url.eu-north-1.on.aws/";
export const ADMIN_EMAILS = ['malin.nauska@sspnorth.se', 'tan.chu@sspnorth.se'];